import { motion } from "framer-motion";
import { Globe } from "lucide-react";
import { Label } from "@/components/ui/label";
import { FormData, languageOptions } from "../types";

interface LanguageStepProps {
  formData: FormData;
  onChange: (field: keyof FormData, value: string) => void;
}

const LanguageStep = ({ formData, onChange }: LanguageStepProps) => {
  return (
    <motion.div
      key="language"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className="space-y-6"
    >
      <div className="text-center mb-8">
        <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
          <Globe className="w-8 h-8 text-primary" />
        </div>
        <h2 className="font-heading text-2xl font-bold text-foreground mb-2">
          Song Language
        </h2>
        <p className="text-muted-foreground">
          Choose the language for your song lyrics.
        </p>
      </div>

      <div className="space-y-4">
        <Label>Select one *</Label>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          {languageOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange("language", option.value)}
              className={`p-4 rounded-xl border-2 transition-all text-center ${
                formData.language === option.value
                  ? "border-primary bg-primary/5"
                  : "border-border hover:border-primary/50"
              }`}
            >
              <span className="font-medium">{option.label}</span>
            </button>
          ))}
        </div>
        <p className="text-sm text-muted-foreground">
          Choose the language you would like the lyrics to be written in.
          If you select English and Spanish, the song will include a natural mix of both.
        </p>
      </div>

      <div className="space-y-4">
        <Label>Singer Gender *</Label>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {[
            { value: "male", label: "Male" },
            { value: "female", label: "Female" },
            { value: "male_and_female", label: "Male and Female" },
            { value: "surprise_me", label: "Surprise Me" },
          ].map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange("singerGender", option.value)}
              className={`p-4 rounded-xl border-2 transition-all text-center ${
                formData.singerGender === option.value
                  ? "border-primary bg-primary/5"
                  : "border-border hover:border-primary/50"
              }`}
            >
              <span className="font-medium">{option.label}</span>
            </button>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default LanguageStep;
